// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a8fba19a","453":"cfe193aa","455":"2ef9d00f","977":"432a780b"}[chunkId] + ".chunk.js";
};